import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, deleteData, getPageType } from '../../services/seoContentServices';
import { Modal, Button, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import Select from 'react-select';

const Seocontent = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({ id: '', page_name: '', meta_title: '', meta_description: '' });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageTypes, setPageTypes] = useState([{ value: "", label: "Select Page Name"}]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // Fetch data list
  const fetchData = useCallback(async () => {
    setLoading(true);
    try{    
    const data = await getData();
    setDataList(data);
    }
    catch (error) { 
      console.error('Error fetching data:', error);
    }
    finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    const fetchPageType = async () => {
      try {
        const data = await getPageType(); // Fetch data from the service
        const formatedOptions  = data?.map(item=>({
          'value':item.page_value,
          'label':item.page_title 
        }))
        setPageTypes(formatedOptions.sort((a,b)=>a.value.localeCompare(b.value))); // Set the types in state
      } catch (error) {
        console.error('Error fetching page type:', error);
      }
    };
 
    fetchPageType();
  }, []);


  // Validate form data
    const validateForm = () => {
    const newErrors = {};
    if (!form.page_name) newErrors.page_name = "Page Name is required";
    if (!form.meta_title) newErrors.meta_title = "Meta Title is required";
    if (!form.meta_description) newErrors.meta_description = "Meta Description is required";
    if (form.meta_title.length < 20 || form.meta_title.length > 70) newErrors.meta_title = "Meta Title should be between 20 and 70 characters";
    if (form.meta_description.length < 70 || form.meta_description.length > 160) newErrors.meta_description = "Meta Description should be between 70 and 160 characters";
    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);  
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    try{
       let updatedErrors = { ...errors };
    if (value) {
        updatedErrors[name] = ''; // Clear error if corrected
      }
    if (name === "page_name") {
            const isDuplicate = dataList.some(
              (item) => item.page_name?.toLowerCase() === value.toLowerCase()
            );

            if (isDuplicate) {
              updatedErrors[name] = "Page name already exists";
            } else {
              updatedErrors[name] = ''; // Clear error if unique
            }
          }
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors(updatedErrors);
    }
    catch (error) {
      console.error('Error in handleChange:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
        return
      }
    if (modalType === 'add') {

     let response = await addData(form);
     if (response.status === 200||201) {
        toast.success("Added Successfully!", {
          position: 'top-right',
          autoClose: 3000,
        });
      } 
      else{
          toast.error(response.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
      console.log((response?.message || "Failed to process request."));
      }
    } else if (modalType === 'edit') {
      let  response = await updateData(form);
      if (response && response.status === 200) {
        toast.success("Updated Successfully!", {position: 'top-right',autoClose: 3000,});
              }
      else{
      toast.error(response.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
      console.log((response?.message || "Failed to process request."));
          }
    }
    fetchData();  // Re-fetch data after adding/editing
    setShowModal(false);
  };

  const handleDelete = async () => {
    try{
    if (selectedData) {
      // Optimistically remove the data from the list
      setDataList((prev) => prev.filter((data) => data.id !== selectedData.id));
      // Proceed with the actual delete request
      await deleteData(selectedData);
      setShowDeleteConfirmModal(false);
      toast.success("Deleted Successfully!", {position: 'top-right',autoClose: 3000});
    }
  }
  catch (error) {
        console.error('Error deleting data:', error);
      }
  };

  const openModal = (type, data = { id: '', page_name: '', meta_title: '', meta_description: '' }) => {
    setModalType(type);
    setForm(data);
    setShowModal(true);
  };
  
  const openDeleteConfirmModal = (data) => {
    setSelectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    const filtered = dataList.filter(
      (data) =>
        data.page_name.toLowerCase().includes(searchText.toLowerCase()) ||
        data.meta_title.toLowerCase().includes(searchText.toLowerCase()) ||
        data.meta_description.toLowerCase().includes(searchText.toLowerCase()) 
    );
    const sortedData = [...filtered].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    return sortedData;
  }, [dataList, searchText]);

  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '5%',
    },
    {
      name: 'Page name',
      selector: (row) =>  {
      const matched = pageTypes.find(opt => opt.value === row.page_name);
      const label = matched ? matched.label : row.page_name;
      return <span title={label}>{label}</span>;
      },
      sortable: true,
      width:'15%'
    },
    {
      name: 'Meta title',
      selector: (row) => (<span title={row.meta_title}>{row.meta_title}</span>),
      sortable: true,
      width:'20%'
    },
    {
      name: 'Meta Description',
      cell: (row) => (<span title={row.meta_description}>{row.meta_description}</span>),
      sortable: true,
      width:'40%',

    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
          <Button variant="danger" size="sm" onClick={() => openDeleteConfirmModal(row)} > Delete </Button>
        </div>
      ),
      width:'20%'
    },
  ];


  const customStyles = (hasError) => ({
  control: (provided, state) => ({
    ...provided,
    borderColor: hasError ? '#f5c2c7' : provided.borderColor, // Light red border
    boxShadow: hasError
      ? '0 0 0 1px rgba(167, 16, 31, 0.91)' // Light red outline glow
      : state.isFocused
        ? '0 0 0 1px #2684FF'
        : provided.boxShadow,
    '&:hover': {
      borderColor: hasError ? '#f5c2c7' : provided.borderColor,
    },
  }),
});

return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>SEO Config <b>/ Meta Tags</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>

          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
              <Form.Group className="mb-3">
              <Form.Label className='form-label-custom'>Page Name<small className='text-danger'>*</small> </Form.Label>
              <Select
                  id="page_name"
                  name="page_name"
                  value={pageTypes.find(opt => opt.value === form.page_name)}
                  onChange={(selectedOption) =>
                    handleChange({
                      target: {
                        name: 'page_name',
                        value: selectedOption?.value || ''
                      }
                    })
                  }   
                  options={pageTypes || []}
                  styles={customStyles(!!errors.page_name)}
                  placeholder="Select Page"
                />
                {errors.page_name && (
                  <div className="invalid-feedback d-block">
                    {errors.page_name}
                  </div>
                )}
              {/* <Form.Control className="form-select mb-3" as="select" name="page_name" value={form.page_name} onChange={handleChange} isInvalid = {!!errors.page_name} > */}
                    {/* <option value="">Select Type</option>
                    {pageTypes.map((page) => (
                      <option key={page.id} value={page.value}>
                        {page.page_title}
                      </option>
                    ))}
                  </Form.Control>
                <Form.Control.Feedback type="invalid">{errors.page_name}</Form.Control.Feedback> */}

              </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className='form-label-custom'>Meta title <small className='text-danger'>*</small><small className='text-primary'> Char Limit: 20 -70 | Current Char Count: {form.meta_title.length}</small> </Form.Label>
                  <Form.Control type="text" name="meta_title" value={form.meta_title} onChange={handleChange} isInvalid ={!!errors.meta_title} />
                <Form.Control.Feedback type="invalid">{errors.meta_title}</Form.Control.Feedback>
                  
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className='form-label-custom'>Meta description <small className='text-danger'>*</small> <small className='text-primary'>Char Limit: 70 -160 | Current Char Count: {form.meta_description.length}</small></Form.Label>
                  <Form.Control as="textarea"  rows={8} name="meta_description" value={form.meta_description} onChange={handleChange} isInvalid = {!!errors.meta_description} />
                <Form.Control.Feedback type="invalid">{errors.meta_description}</Form.Control.Feedback>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer className='border-0'>
              <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
              <Button variant="primary" onClick={handleSubmit}> {modalType === 'add' ? 'Add' : 'Save'} </Button>
            </Modal.Footer>
          </Modal>

          {/* Delete Confirmation Modal */}
          <Modal show={showDeleteConfirmModal} onHide={() => setShowDeleteConfirmModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this row?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowDeleteConfirmModal(false)}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
        )}
      </div>
    </div>
  );
};

export default Seocontent;